/**
 * Simple config 
 * For local config create config.js
 */

module.exports =  {
    "API_URL": "https://new-cms-contente-backend.dev.cdwv.pl/api",
    "API_PUBLIC": "https://new-cms-contente-backend.dev.cdwv.pl",
    "PUBLIC_SITE_URL": "http://__SITE_SLUG__.contente.net",
    "DEV": false,
    "ROLES": ['ROLE_USER','ROLE_ADMIN'],
    "UNSPLASH_ACCESS_KEY": "475919daaf6f38937bc3daf4c47a3d8fb0572e2ecc22b5097fb5745a39b4f882",
    "UNSPLASH_SECRET_KEY": "cdd5aa0ce44dc3e0c6df71229df22c322dd959ffbcbcc1020b4e5b197a667e16",
    "NOUN_PROJECT_KEY": "155322dd33d14129b816bd42d65f3512",
    "NOUN_PROJECT_SECRET": "9d12fb2fc9164346bcb908702d8445ab"
};


// WEBPACK FOOTER //
// ./src/config.js